import * as Yup from 'yup';
export const UPDATE_DETAILS_VALIDATION_SCHEMA = Yup.object({
	firstName: Yup.string().required('First name is required.'),
	name: Yup.string().required('Last name is required.'),
	phone: Yup.string().required('Your phone number is required to secure your account.'),
});
